/**
 * Kannada number words, every one from 1 to 99 listed rather than built by rule, with the spoken forms recognizers
 * also return (ಇಪ್ಪತ್ಮೂರು beside ಇಪ್ಪತ್ತಮೂರು). Hundreds from 200 to 900 are one word (ಐನೂರು 500); "-ನೂರ" and
 * "ಸಾವಿರದ" are the forms joined to what follows (ಸಾವಿರದ ಐನೂರು, 1,500). "And a half" (ಎಂಟೂವರೆ) is taken apart by
 * normalization before this table is read.
 */
export const KN_NUMBERS = {
    values: {
        ಒಂದು: 1,
        ಎರಡು: 2,
        ಮೂರು: 3,
        ನಾಲ್ಕು: 4,
        ಐದು: 5,
        ಆರು: 6,
        ಏಳು: 7,
        ಎಂಟು: 8,
        ಒಂಬತ್ತು: 9,
        ಒಂಭತ್ತು: 9,
        ಹತ್ತು: 10,
        ಹನ್ನೊಂದು: 11,
        ಹನ್ನೆರಡು: 12,
        ಹದಿಮೂರು: 13,
        ಹದಿನಾಲ್ಕು: 14,
        ಹದಿನೈದು: 15,
        ಹದಿನಾರು: 16,
        ಹದಿನೇಳು: 17,
        ಹದಿನೆಂಟು: 18,
        ಹತ್ತೊಂಬತ್ತು: 19,
        ಇಪ್ಪತ್ತು: 20,
        ಇಪ್ಪತ್ತೊಂದು: 21,
        ಇಪ್ಪತ್ತೆರಡು: 22,
        ಇಪ್ಪತ್ತಮೂರು: 23,
        ಇಪ್ಪತ್ಮೂರು: 23,
        ಇಪ್ಪತ್ತನಾಲ್ಕು: 24,
        ಇಪ್ಪತ್ನಾಲ್ಕು: 24,
        ಇಪ್ಪತ್ತೈದು: 25,
        ಇಪ್ಪತ್ತಾರು: 26,
        ಇಪ್ಪತ್ತೇಳು: 27,
        ಇಪ್ಪತ್ತೆಂಟು: 28,
        ಇಪ್ಪತ್ತೊಂಬತ್ತು: 29,
        ಮೂವತ್ತು: 30,
        ಮೂವತ್ತೊಂದು: 31,
        ಮೂವತ್ತೆರಡು: 32,
        ಮೂವತ್ತಮೂರು: 33,
        ಮೂವತ್ಮೂರು: 33,
        ಮೂವತ್ತನಾಲ್ಕು: 34,
        ಮೂವತ್ನಾಲ್ಕು: 34,
        ಮೂವತ್ತೈದು: 35,
        ಮೂವತ್ತಾರು: 36,
        ಮೂವತ್ತೇಳು: 37,
        ಮೂವತ್ತೆಂಟು: 38,
        ಮೂವತ್ತೊಂಬತ್ತು: 39,
        ನಲವತ್ತು: 40,
        ನಲುವತ್ತು: 40,
        ನಲವತ್ತೊಂದು: 41,
        ನಲವತ್ತೆರಡು: 42,
        ನಲವತ್ತಮೂರು: 43,
        ನಲವತ್ಮೂರು: 43,
        ನಲವತ್ತನಾಲ್ಕು: 44,
        ನಲವತ್ನಾಲ್ಕು: 44,
        ನಲವತ್ತೈದು: 45,
        ನಲವತ್ತಾರು: 46,
        ನಲವತ್ತೇಳು: 47,
        ನಲವತ್ತೆಂಟು: 48,
        ನಲವತ್ತೊಂಬತ್ತು: 49,
        ಐವತ್ತು: 50,
        ಐವತ್ತೊಂದು: 51,
        ಐವತ್ತೆರಡು: 52,
        ಐವತ್ತಮೂರು: 53,
        ಐವತ್ಮೂರು: 53,
        ಐವತ್ತನಾಲ್ಕು: 54,
        ಐವತ್ನಾಲ್ಕು: 54,
        ಐವತ್ತೈದು: 55,
        ಐವತ್ತಾರು: 56,
        ಐವತ್ತೇಳು: 57,
        ಐವತ್ತೆಂಟು: 58,
        ಐವತ್ತೊಂಬತ್ತು: 59,
        ಅರವತ್ತು: 60,
        ಅರುವತ್ತು: 60,
        ಅರವತ್ತೊಂದು: 61,
        ಅರವತ್ತೆರಡು: 62,
        ಅರವತ್ತಮೂರು: 63,
        ಅರವತ್ಮೂರು: 63,
        ಅರವತ್ತನಾಲ್ಕು: 64,
        ಅರವತ್ನಾಲ್ಕು: 64,
        ಅರವತ್ತೈದು: 65,
        ಅರವತ್ತಾರು: 66,
        ಅರವತ್ತೇಳು: 67,
        ಅರವತ್ತೆಂಟು: 68,
        ಅರವತ್ತೊಂಬತ್ತು: 69,
        ಎಪ್ಪತ್ತು: 70,
        ಎಪ್ಪತ್ತೊಂದು: 71,
        ಎಪ್ಪತ್ತೆರಡು: 72,
        ಎಪ್ಪತ್ತಮೂರು: 73,
        ಎಪ್ಪತ್ಮೂರು: 73,
        ಎಪ್ಪತ್ತನಾಲ್ಕು: 74,
        ಎಪ್ಪತ್ನಾಲ್ಕು: 74,
        ಎಪ್ಪತ್ತೈದು: 75,
        ಎಪ್ಪತ್ತಾರು: 76,
        ಎಪ್ಪತ್ತೇಳು: 77,
        ಎಪ್ಪತ್ತೆಂಟು: 78,
        ಎಪ್ಪತ್ತೊಂಬತ್ತು: 79,
        ಎಂಬತ್ತು: 80,
        ಎಂಭತ್ತು: 80,
        ಎಂಬತ್ತೊಂದು: 81,
        ಎಂಬತ್ತೆರಡು: 82,
        ಎಂಬತ್ತಮೂರು: 83,
        ಎಂಬತ್ಮೂರು: 83,
        ಎಂಬತ್ತನಾಲ್ಕು: 84,
        ಎಂಬತ್ನಾಲ್ಕು: 84,
        ಎಂಬತ್ತೈದು: 85,
        ಎಂಬತ್ತಾರು: 86,
        ಎಂಬತ್ತೇಳು: 87,
        ಎಂಬತ್ತೆಂಟು: 88,
        ಎಂಬತ್ತೊಂಬತ್ತು: 89,
        ತೊಂಬತ್ತು: 90,
        ತೊಂಬತ್ತೊಂದು: 91,
        ತೊಂಬತ್ತೆರಡು: 92,
        ತೊಂಬತ್ತಮೂರು: 93,
        ತೊಂಬತ್ಮೂರು: 93,
        ತೊಂಬತ್ತನಾಲ್ಕು: 94,
        ತೊಂಬತ್ನಾಲ್ಕು: 94,
        ತೊಂಬತ್ತೈದು: 95,
        ತೊಂಬತ್ತಾರು: 96,
        ತೊಂಬತ್ತೇಳು: 97,
        ತೊಂಬತ್ತೆಂಟು: 98,
        ತೊಂಬತ್ತೊಂಬತ್ತು: 99,
        ಇನ್ನೂರು: 200,
        ಇನ್ನೂರ: 200,
        ಮುನ್ನೂರು: 300,
        ಮುನ್ನೂರ: 300,
        ನಾನೂರು: 400,
        ನಾನೂರ: 400,
        ಐನೂರು: 500,
        ಐನೂರ: 500,
        ಆರುನೂರು: 600,
        ಆರುನೂರ: 600,
        ಏಳುನೂರು: 700,
        ಏಳುನೂರ: 700,
        ಎಂಟುನೂರು: 800,
        ಎಂಟುನೂರ: 800,
        ಒಂಬೈನೂರು: 900,
        ಒಂಬೈನೂರ: 900,
    },
    multipliers: { ನೂರು: 100, ನೂರ: 100, ಸಾವಿರ: 1000, ಸಾವಿರದ: 1000, ಲಕ್ಷ: 100_000, ಲಕ್ಷದ: 100_000 },
};
//# sourceMappingURL=numbers-kn.js.map